import IDataAccessObjectProperties from '../../../../core/DAL/DAO/IDataAccessObjectProperties';

export default class DistributionBundlesDAOProperties extends IDataAccessObjectProperties {

	constructor() {

		let path = 'release_bundle';
		let paramDefaults = {};
		let customActions = {
			getReleaseBundles: {
				url: path,
				method: 'GET',
				isArray: true
			},
            searchReleaseBundles:{
                url: `${path}/search`,
                method: 'GET',
            },
			getReleaseBundlesNoSpinner: {
				url: path,
				method: 'GET',
				isArray: true,
				params: {
					$no_spinner: true
				},
			},
			getReleaseBundle: {
				url: `${path}/:release_bundle`,
				method: 'GET',
			},
			getSites: {
                url: `distribution/edge_nodes`,
				method: 'GET',
				isArray: true
			},
			getSourceArtifactories: {
				url:  `${path}/artifactories`,
				method: 'GET',
				isArray: true
			},
			getGeneralDistributionTracking: {
				url: `general_distribution_tracking`,
				method: 'GET',
				isArray: true,
				params: {
					$no_spinner: true
				}
			},
			getTargetSiteTracking: {
				url: `target_site_tracking`,
				method: 'GET',
				isArray: true,
				params: {
					$no_spinner: true
				}
			},
		};

		super(path, paramDefaults, null, customActions);
	}
};

DistributionBundlesDAOProperties.META = {
	name: 'DistributionBundlesDAOProperties'
};



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/DAO/bundles/DistributionBundlesDAOProperties.js